import React from 'react';
import { useReducedMotion } from '@react-spring/web';
import { AnimatedVideoProps } from './AnimatedVideo.types';
import styled from 'threads5/styles/styled';

// helpers
import { Lazy } from 'src/components-v2/Helpers';
import { isAutomatedBrowser } from 'src/lib/browser-utils';

const AnimatedVideo = React.forwardRef<HTMLVideoElement, AnimatedVideoProps>(
  (
    {
      isLazy = false,
      className = '',
      width = '',
      height = '',
      sources = [],
      ariaLabel = '',
      ...props
    },
    ref,
  ) => {
    // Autoplaying video can't be paused by `prefers-reduced-motion` or Happo's
    // CSS animation freezing — hold the first frame instead (same treatment as
    // LottiePlayer) so users get a static poster and captures are deterministic.
    const isAutomated = isAutomatedBrowser();
    const freeze = useReducedMotion() || isAutomated;
    return (
      <Lazy isLazy={isLazy} height={height}>
        <video
          // we add a key to the video element re-renders
          // this is easier than having to pass a ref to the component
          key={`${sources[0]?.src}-${freeze ? 'frozen' : 'animated'}`}
          data-testid='video'
          className={className}
          autoPlay={!freeze}
          crossOrigin={isAutomated ? 'anonymous' : undefined}
          loop
          muted
          playsInline
          width={width}
          height={height}
          ref={ref}
          aria-label={ariaLabel}
          {...props}
        >
          {sources?.map((item, i) => {
            return <source {...item} key={`video-source-${i}`} />;
          })}
        </video>
      </Lazy>
    );
  },
);

export default styled(AnimatedVideo)({});
